import React from "react";
import styles from "./BotTableHeader.module.css";

export const BotTableHeader: React.FC = () => {
    return <div className={styles.wrapper}>
        <span className={styles.dealerCell}>Dealer</span>
        <span className={styles.websiteCell}>Website</span>
        <span className={styles.convCountAllCell}>Conversation count (all time)</span>
        <span className={styles.convCountMonthlyCell}>Conversation count (monthly)</span>
        <span className={styles.usedConvosCell}>% of used convos</span>
        <span className={styles.actionsCell}>Actions</span>
    </div>
}
